module.exports = __webpack_public_path__ + "img/m-activity-banner.71ecba54.png";